import React, { FC } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';

import PrevIcon from 'assets/prev.svg';
import NextIcon from 'assets/next.svg';

import styles from './paginationLink.module.scss';

interface IProps {
  page: number;
  isPrev?: boolean;
  isNext?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  linkRenderer?: (page: number) => string;
  ariaLabel?: string;
}

const PaginationLink: FC<IProps> = ({
  page,
  isPrev,
  isNext,
  isSelected,
  isDisabled,
  linkRenderer,
  ariaLabel,
}) => {
  const renderPage = () => {
    if (isPrev) {
      return (
        <PrevIcon className={styles.icon} />
      );
    }
    if (isNext) {
      return (
        <NextIcon className={styles.icon} />
      );
    }
    return page;
  };

  if (isSelected || isDisabled) {
    return (
      <span
        className={cx(styles.link, {
          [styles.linkSelected]: isSelected,
          [styles.linkDisabled]: isDisabled,
        })}
      >
        {renderPage()}
      </span>
    );
  }

  const defaultLinkRenderer = (p: number) => (p === 1 ? '' : `${p.toString()}`);
  const link = linkRenderer ? linkRenderer(page) : defaultLinkRenderer(page);

  return (
    <Link
      className={styles.link}
      to={link}
      aria-label={ariaLabel}
    >
      {renderPage()}
    </Link>
  );
};

export default PaginationLink;
